export const REPRICING_INVENTORY_STATUS_STATE_DISPLAY = {
  MISSING_PRICE: {
    icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>',
    title: 'Missing Price',
    chipStyleClass: 'inventory-health-chip--missing',
    tooltip: {
      header: 'Missing Price',
      body: 'Item has no base price set. Analytics are paused.',
      action: 'Set Price',
    },
    conclusion: {
      title: 'Configuration Missing',
      description: 'This item currently has no active price. Sales and analytics cannot proceed until a base price is defined.',
    },
  },
  DEAD_STOCK: {
    icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21h6v-6a6 6 0 0 0-9 0v6"></path><path d="M9 13a3 3 0 1 0 5-6"></path></svg>',
    title: 'Dead Stock',
    chipStyleClass: 'inventory-health-chip--dead',
    tooltip: {
      header: 'Dead Stock',
      body: 'Zero sales recorded over an extended period.',
      action: 'Liquidate',
    },
    conclusion: {
      title: 'Stagnant Inventory Alert',
      description: 'Zero sales recorded over an extended period. Capital is tied up in non-performing assets; liquidation is recommended.',
    },
  },
  NO_DEMAND: {
    icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="8" y1="12" x2="16" y2="12"></line></svg>',
    title: 'No Demand',
    chipStyleClass: 'inventory-health-chip--nodemand',
    tooltip: {
      header: 'No Demand',
      body: 'Inventory exists, but buy-intent is zero.',
      action: 'Check Listing',
    },
    conclusion: {
      title: 'No Market Demand',
      description: 'Inventory levels are sufficient, but there is currently no market demand or sales velocity detected. Check listing visibility.',
    },
  },
  STOCK_OUT_HIGH_DEMAND: {
    icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.115.385-2.256 1-3.243 1.25.98 2.5 2.243 2.5 3.243z"></path></svg>',
    title: 'Stock Out High Demand',
    chipStyleClass: 'inventory-health-chip--stockout-hot',
    tooltip: {
      header: 'Stock Out High Demand (Ratio 0)',
      body: 'High demand exists but inventory is depleted.',
      action: 'Restock ASAP',
    },
    conclusion: {
      title: 'Revenue Loss Alert',
      description: 'High market demand exists, but inventory is depleted. Immediate restocking is required to capture potential lost sales.',
    },
  },
  STOCK_OUT_RESTOCKING: {
    icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M21 2v6h-6"></path><path d="M3 12a9 9 0 0 1 15-6.7L21 8"></path><path d="M3 22v-6h6"></path><path d="M21 12a9 9 0 0 1-15 6.7L3 16"></path></svg>',
    title: 'Stock Out Restocking',
    chipStyleClass: 'inventory-health-chip--restock',
    tooltip: {
      header: 'Stock Out Restocking (Ratio 0)',
      body: 'Out of stock, but replenishment is en route.',
      action: 'Track Order',
    },
    conclusion: {
      title: 'Inbound Shipment Pending',
      description: 'Inventory is currently out of stock, but a restocking order is in progress. Monitor ETA closely.',
    },
  },
  OVERSTOCK_CRITICAL: {
    icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M12 8v8"></path><path d="M16 12l-4 4-4-4"></path></svg>',
    title: 'Critical Overstock',
    chipStyleClass: 'inventory-health-chip--over-crit',
    tooltip: {
      header: 'Critical Overstock',
      range: '(> 3.0)',
      body: 'Excess inventory is critically high. Costs are escalating.',
      action: 'Aggressive Sale',
    },
    conclusion: {
      title: 'Critical Oversupply Warning',
      description: 'Supply levels are critically high relative to sales velocity. Holding costs are increasing; aggressive pricing action needed.',
    },
  },
  OVERSTOCK_HIGH: {
    icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M12 8v8"></path><path d="M16 12l-4 4-4-4"></path></svg>',
    title: 'High Overstock',
    chipStyleClass: 'inventory-health-chip--over-high',
    tooltip: {
      header: 'High Overstock',
      range: '(1.5 - 3.0)',
      body: 'Supply significantly exceeds current sales velocity.',
      action: 'Decrease Price',
    },
    conclusion: {
      title: 'High Inventory Surplus',
      description: 'Inventory levels exceed current demand projections. Corrective action is needed to prevent long-term dead stock.',
    },
  },
  BALANCED: {
    icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="m9 12 2 2 4-4"></path></svg>',
    title: 'Balanced',
    chipStyleClass: 'inventory-health-chip--balanced',
    tooltip: {
      header: 'Balanced',
      range: '(1.0 - 1.5)',
      body: 'Inventory levels perfectly match sales velocity.',
      action: 'Maintain',
    },
    conclusion: {
      title: 'Optimal Inventory Health',
      description: 'Supply perfectly matches the current demand velocity. No immediate corrective action is required.',
    },
  },
  UNDERSTOCK_MILD: {
    icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline></svg>',
    title: 'Mild Understock',
    chipStyleClass: 'inventory-health-chip--under-mild',
    tooltip: {
      header: 'Mild Understock',
      range: '(0.75 - 1.0)',
      body: 'Sales are accelerating. Safety stock is thinning.',
      action: 'Plan Reorder',
    },
    conclusion: {
      title: 'Rising Demand Trend',
      description: 'Sales velocity is increasing. Inventory levels should be monitored closely to prevent future stockouts.',
    },
  },
  UNDERSTOCK_MODERATE: {
    icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>',
    title: 'Moderate Understock',
    chipStyleClass: 'inventory-health-chip--under-mod',
    tooltip: {
      header: 'Moderate Understock',
      range: '(0.5 - 0.75)',
      body: 'Demand is stripping supply faster than restock rate.',
      action: 'Raise Price',
    },
    conclusion: {
      title: 'Stock Depletion Alert',
      description: 'Stock is depleting fast (Velocity > Restock Rate). Immediate price adjustment is suggested to maintain inventory health.',
    },
  },
  UNDERSTOCK_CRITICAL: {
    icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="m16 12-4-4-4 4"></path><path d="M12 16V8"></path></svg>',
    title: 'Critical Understock',
    chipStyleClass: 'inventory-health-chip--under-crit',
    tooltip: {
      header: 'Critical Understock',
      range: '(< 0.5)',
      body: 'Inventory is dangerously low vs high demand.',
      action: 'Maximize Profit',
    },
    conclusion: {
      title: 'Critical Scarcity Warning',
      description: 'Inventory is dangerously low compared to high demand. Premium pricing strategies are recommended to slow depletion.',
    },
  },
};
